export const US_COUNTRY = 'United States'
export const CANADA_COUNTRY = 'Canada'
export const PRIORITY_COUNTRIES = [US_COUNTRY, CANADA_COUNTRY]
